import { render, staticRenderFns } from "./emptyHint.vue?vue&type=template&id=30839a2f&"
import script from "./emptyHint.vue?vue&type=script&lang=ts&"
export * from "./emptyHint.vue?vue&type=script&lang=ts&"
import style0 from "./emptyHint.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports